/* The Curioso — global storefront behavior */
(function () {
  'use strict';

  var money = function (cents) {
    var format = (window.theme && window.theme.moneyFormat) || '₹ {{amount}}';
    var amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return format.replace(/\{\{\s*amount\s*\}\}/g, amount);
  };

  /* ---------- mobile menu ---------- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      menu.classList.toggle('open');
    });
  }

  /* ---------- header search ---------- */
  var searchPanel = document.querySelector('[data-search-panel]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-toggle]')) {
      e.preventDefault();
      if (searchPanel) {
        searchPanel.classList.toggle('open');
        if (searchPanel.classList.contains('open')) {
          var input = searchPanel.querySelector('[data-search-input]');
          if (input) { setTimeout(function () { input.focus(); }, 100); }
        }
      }
    }
  });

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  var drawerBody = document.getElementById('CartDrawerBody');

  function openDrawer() { if (drawer) { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); } }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function renderDrawer(cart) {
    if (!drawerBody) return;
    if (!cart.items || cart.items.length === 0) {
      drawerBody.innerHTML = '<p style="opacity:.7;padding:2rem 0;text-align:center">Your cart is empty.</p>';
      return;
    }
    var html = '';
    cart.items.forEach(function (item) {
      html += '<div class="cart-line" style="grid-template-columns:64px 1fr;gap:1rem">' +
        '<div class="thumb">' + (item.image ? '<img src="' + item.image + '" alt="">' : '') + '</div>' +
        '<div><div class="nm" style="font-size:1rem">' + item.product_title + '</div>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="variant">' + item.variant_title + '</div>' : '') +
        '<div class="variant">' + item.quantity + ' × ' + money(item.final_price) + '</div>' +
        '<a class="remove" href="#" data-remove="' + item.key + '">Remove</a></div></div>';
    });
    html += '<div style="padding:1.4rem 0;border-top:1px solid var(--line);margin-top:1rem">' +
      '<div style="display:flex;justify-content:space-between;font-size:1.1rem;margin-bottom:1rem">' +
      '<span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
      '<a href="/cart" class="btn btn-ink" style="width:100%;margin-bottom:.7rem">View Cart</a>' +
      '<a href="/checkout" class="btn btn-ink" style="width:100%;background:var(--sage-deep);color:var(--cream);border-color:var(--sage-deep)">Checkout</a></div>';
    drawerBody.innerHTML = html;
  }

  function refreshCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = '(' + (cart.item_count || 0) + ')';
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* open drawer from header cart icon */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cart-open]');
    if (trigger) {
      e.preventDefault();
      fetchCart().then(function (cart) { renderDrawer(cart); openDrawer(); });
    }
  });

  /* remove from drawer */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (rm) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: rm.getAttribute('data-remove'), quantity: 0 })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        renderDrawer(cart); refreshCartCount(cart);
      });
    }
  });

  /* ---------- add to cart (AJAX) ---------- */
  var addForm = document.querySelector('[data-product-form]');
  if (addForm) {
    addForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = addForm.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: addForm.querySelector('[name="id"]').value,
          quantity: parseInt((addForm.querySelector('[name="quantity"]') || {}).value || 1, 10)
        })
      }).then(function (r) { return r.json(); }).then(function () {
        return fetchCart();
      }).then(function (cart) {
        renderDrawer(cart); refreshCartCount(cart); openDrawer();
        if (btn) { btn.textContent = original; btn.disabled = false; }
      }).catch(function () {
        if (btn) { btn.textContent = original; btn.disabled = false; }
      });
    });
  }

  /* ---------- quantity stepper ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty]');
    if (!step) return;
    var input = step.parentNode.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += (step.getAttribute('data-qty') === 'up' ? 1 : -1);
    if (val < 1) val = 1;
    input.value = val;
  });

  /* ---------- product variant selection ---------- */
  var variantData = window.theme && window.theme.variants;
  if (variantData && addForm) {
    var selects = addForm.querySelectorAll('[data-option]');
    var idField = addForm.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var submitBtn = addForm.querySelector('[type="submit"]');
    function updateVariant() {
      var chosen = [];
      selects.forEach(function (s) { chosen.push(s.value); });
      var match = variantData.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (match) {
        idField.value = match.id;
        if (priceEl) priceEl.innerHTML = '<span class="cur">₹</span> ' + (match.price / 100).toLocaleString();
        if (submitBtn) {
          submitBtn.disabled = !match.available;
          submitBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });
  }

  /* ---------- product gallery thumbnails ---------- */
  var gallery = document.querySelector('.product-gallery');
  if (gallery) {
    var mainImg = gallery.querySelector('.main img');
    gallery.querySelectorAll('.thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (mainImg) mainImg.src = b.getAttribute('data-full');
        gallery.querySelectorAll('.thumbs button').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
      });
    });
  }
})();
